import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AdminReceiptEditPage } from './AdminReceiptEditPage';

// When reached from a review's "Edit using JSON" action, this carries the
// originating review id so Back and post-save both return to that review
// instead of the receipt detail page. Absent for the receipt-detail entry point.
const searchSchema = z.object({
  returnToReviewId: z.string().optional(),
});

export const Route = createFileRoute('/_protected/admin/internal-tools/receipts/$receiptId/edit/')({
  component: AdminReceiptEditPage,
  validateSearch: searchSchema,
});
